import { CustomFilterInfoText } from '@modules/common/components/CustomFilterInfoText';
import { CustomFiltersModalActions } from '@modules/common/components/CustomFilterModalActions';
import { CustomFilterModalEditQuery } from '@modules/common/components/CustomFilterModalEditQuery';
import { CustomFilterModalNameInput } from '@modules/common/components/CustomFilterModalNameInput';
import { QueryBuilderStoreProvider } from '@modules/queryBuilder/store/QueryBuilderStoreProvider';
import { InfoOutlined } from '@mui/icons-material';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
} from '@mui/material';
import { useState } from 'react';
import { WhereClause } from 'v2/core/services/queryBuilder/whereClause';

interface CreateCustomFilterModalProps {
  whereClause: WhereClause;
  onClose: () => void;
}

export const CreateCustomFilterModal = ({
  whereClause,
  onClose,
}: CreateCustomFilterModalProps) => {
  const [filterName, setFilterName] = useState<string>();

  return (
    <QueryBuilderStoreProvider>
      <DialogContent sx={{ p: 0 }} data-testid="create-custom-filter-modal">
        <DialogTitle>
          Save as Custom Filter
          <Tooltip
            arrow
            title={
              <CustomFilterInfoText
                typographyProps={{ variant: 'caption' }}
                linkProps={{
                  target: '_blank',
                  color: 'inherit',
                  display: 'block',
                }}
              />
            }
          >
            <InfoOutlined
              sx={{ fontSize: 'inherit', color: 'text.secondary', ml: 1 }}
            />
          </Tooltip>
        </DialogTitle>
        <DialogContent dividers>
          <CustomFilterModalNameInput
            filterName={filterName}
            setFilterName={setFilterName}
          />
          <CustomFilterModalEditQuery whereClause={whereClause} />
        </DialogContent>
        <DialogActions>
          <CustomFiltersModalActions
            onClose={onClose}
            filterName={filterName}
          />
        </DialogActions>
      </DialogContent>
    </QueryBuilderStoreProvider>
  );
};
